<template>
  <div class="home-dashboard">
    <div v-if="myDashboardData == null" class="home-dashboard__loading">
      <MyLoader />
    </div>

    <template v-else>
      <section class="home-dashboard__status" aria-label="투자 현황">
        <InvestCountBoard />
      </section>
      <MyAccount
        :withdraw-balance="withdrawBalance"
        :withdraw-balance-loading="withdrawBalanceLoading"
      />
    </template>
  </div>
</template>

<script>
import MyLoader from '@/components/MyLoader.vue'
import InvestCountBoard from '@/components/myfunda/invest/InvestCountBoard.vue'
import MyAccount from '@/components/myfunda/home/MyAccount.vue'

export default {
  props: {
    myDashboardData: {
      type: Object,
      default: null,
    },
    withdrawBalance: {
      type: Number,
      default: 0,
    },
    withdrawBalanceLoading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MyLoader,
    InvestCountBoard,
    MyAccount,
  },
}
</script>

<style lang="scss" scoped>
.home-dashboard {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.home-dashboard__loading,
.home-dashboard__status {
  background: #fff;
  border: 1px solid #e6eaef;
  border-radius: 14px;
}

.home-dashboard__loading {
  min-height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 959px) {
  .home-dashboard {
    gap: 18px;
  }

  .home-dashboard__loading,
  .home-dashboard__status {
    border-radius: 12px;
  }
}
</style>
